import React from "react";

export const AcornIcon = ({ width = "27", height = "34" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 27 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9533 5.43219C15.1675 3.82387 14.9676 2.31152 14.8587 1.47687C14.8049 1.06833 14.6045 0.693249 14.2947 0.421533C13.9849 0.149817 13.5869 0 13.1749 0C12.7628 0 12.3648 0.149817 12.055 0.421533C11.7452 0.693249 11.5448 1.06833 11.4911 1.47687C11.3821 2.31152 11.1822 3.82387 8.39642 5.43219C5.3987 7.16345 0 9.34951 0 14.0235C0 15.0311 0.239898 15.9737 0.708698 16.7873C1.02556 17.3351 1.54934 17.687 2.12509 17.8049V18.6995C2.12509 26.3503 8.07456 32.3007 13.1754 34C18.2752 32.3007 24.2257 26.3503 24.2257 18.6995V17.8049C24.5202 17.7452 24.7987 17.6237 25.0427 17.4482C25.2867 17.2728 25.4907 17.0475 25.6411 16.7873C26.1109 15.9737 26.3508 15.0311 26.3508 14.0235C26.3508 9.34951 20.9511 7.16345 17.9533 5.43219"
        fill="#FDC129"
      />
    </svg>
  );
};
